import { InsuranceMatchTile as InsuranceMatchTileData } from "../data/insuranceMatch";

interface Props {
  tile: InsuranceMatchTileData;
}

export const InsuranceMatchTile = ({ tile }: Props) => (
  <>
    <div
      className="relative md:hidden"
      style={{
        width: `${tile.mobileWidth}px`,
        height: `${tile.mobileHeight}px`,
      }}
    >
      <img
        src={tile.mobileSrc}
        alt=""
        aria-hidden="true"
        width={tile.mobileWidth}
        height={tile.mobileHeight}
        className="block h-full w-full"
      />
      <div
        className="absolute flex flex-col gap-3 px-8 pb-8 pt-[60px]"
        style={{
          left: `${tile.mobileCard.left}px`,
          top: `${tile.mobileCard.top}px`,
          width: `${tile.mobileCard.width}px`,
          height: `${tile.mobileCard.height}px`,
          transform: `rotate(${tile.rotation}deg)`,
          transformOrigin: "0 0",
        }}
      >
        <h3 className="text-[16px] leading-[1.2]">{tile.title}</h3>
        <p className="text-[16px] leading-[1.6]">{tile.description}</p>
      </div>
    </div>

    <div
      className="relative hidden md:block"
      style={{ width: `${tile.width}px`, height: `${tile.height}px` }}
    >
      <img
        src={tile.src}
        alt=""
        aria-hidden="true"
        width={tile.width}
        height={tile.height}
        className="block h-full w-full"
      />
      <div
        className="absolute flex flex-col gap-3 px-8 pb-8 pt-[60px]"
        style={{
          left: `${tile.card.left}px`,
          top: `${tile.card.top}px`,
          width: `${tile.card.width}px`,
          height: `${tile.card.height}px`,
          transform: `rotate(${tile.rotation}deg)`,
          transformOrigin: "0 0",
        }}
      >
        <h3 className="text-[19px] leading-[1.2]">{tile.title}</h3>
        <p className="text-[16px] leading-[1.6]">{tile.description}</p>
      </div>
    </div>
  </>
);
